import { render, staticRenderFns } from "./profile-default.vue?vue&type=template&id=4b2bcd80&scoped=true&"
import script from "./profile-default.vue?vue&type=script&lang=js&"
export * from "./profile-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2bcd80",
  null
  
)

export default component.exports